import Swiper from "swiper";

export default function OtherMediaSlider(container) {
  const sliderContainer = container;
  const sliderScrollbar = container.querySelector(".js-other-media-scrollbar");

  const sliderOptions = {
    slideClass: "js-other-media-slide",
    wrapperClass: "js-other-media-wrapper",
    slidesPerView: "auto",
    watchOverflow: true,
    scrollbar: {
      el: sliderScrollbar,
      hide: false,
      draggable: true
    }
  };

  initSlider();

  function initSlider() {
    new Swiper(sliderContainer, sliderOptions);
  }
}
